import { render, staticRenderFns } from "./ProjectProofDrawer.vue?vue&type=template&id=2fcb4159&"
import script from "./ProjectProofDrawer.vue?vue&type=script&lang=js&"
export * from "./ProjectProofDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports